<template>
  <lay-layout v-user-no-select v-if="loginSuccess">
    <lay-header style="height: 81px;" >
      <TopBar :title="title" :logouted="onLogout"></TopBar>
      <FMSIndex :fms="fms" ></FMSIndex>
    </lay-header>
    <lay-body>
      <lay-scroll :height="autoHeight" :style="{'background-color': currentView.backgroundColor}" thumbColor="#e2e2e2">
        <component :is="currentView.page" />
      </lay-scroll>
    </lay-body>
    <lay-footer style="height: 40px;" v-if="false">
      <div style="text-align: center;">Copyright © 2024</div>
    </lay-footer>
  </lay-layout>
  <LoginView  @onLogin="onLogin" v-else/>

</template>

<script setup>
import TopBar from "@/components/TopBar";
import {ref, nextTick, computed, provide, onMounted} from "vue";
import PageOne from  "@/components/system/PageOne";
import PowerCount from "@/components/PowerCount"
import DataMonitor from "@/components/DataMonitor"
import NotFound from "@/components/NotFound"
import FMSIndex from "@/components/FMSIndex";
import {useSize} from "@/assets/js/size";
import {useClock} from "@/assets/js/clock";
import LoginView from "@/components/LoginView";
import axios from "axios";

// const BASE_URL = 'http://192.168.200.188:8081/app';
const BASE_URL = 'https://wk.spepi.cn/app';


const loginSuccess = ref(true);
const access_token = ref();

axios.interceptors.request.use(function (config) {
  config.baseURL = BASE_URL;
  config.headers['apiv'] = '1.0';
  config.headers['pv'] = '1.0';
  config.headers['access_token'] = localStorage.getItem("access_token");
  config.timeout = 3500;
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  if(response.data.code == -2){
    onLogout()
  }
  return response;
},function (error) {
  return Promise.reject(error);
});


const onLogin = function (retInfo){
  if (retInfo.success){
    //登录页面
    window.location.hash = "#/1";
    access_token.value = retInfo.access_token;
    localStorage.setItem('access_token', access_token.value)
    loginSuccess.value = true;
  }
}


const onLogout = function (){
  localStorage.removeItem('access_token');
  loginSuccess.value = false;
  access_token.value = null;
}


onMounted(() => {
  document.addEventListener('contextmenu', event => {
    event.preventDefault();
  })
})

const {seconds} = useClock();

provide("seconds", seconds);

const title = ref('智能电力监控后台')
const fms = [
    {title: "系统图", hash: "#/1", avatar: "layui-icon-picture"},
  {title: "数据监控", hash: "#/2", avatar: "layui-icon-chart-screen"},
  {title: "用电统计", hash: "#/3", avatar: "layui-icon-table"},
]

const {height} = useSize();


const routes = {
  "/1": {page: PageOne, backgroundColor: '#09141F'},
  "/2": {page: DataMonitor, backgroundColor: 'whitesmoke'},
  "/3": {page: PowerCount, backgroundColor: 'whitesmoke'},
  "/111": {page: LoginView, backgroundColor: 'whitesmoke'}
}
const currentPath = ref('#/1');


window.addEventListener('hashchange', () => {
  currentPath.value = window.location.hash
})
const currentView = computed(() => {

  if (routes[currentPath.value.slice(1) || '/']){
    return routes[currentPath.value.slice(1) || '/'];
  }
  return {
    page: NotFound, backgroundColor: 'whitesmoke'
  }
})

const autoHeight = computed(() => {
  return (height.value - 81) + "px";
});

const target = ref()
nextTick(()=>{
  target.value=document.querySelector(".layui-body");
})


</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.layui-tab-brief>.layui-tab-head>.layui-tab-title > .layui-this{
  color: #1e9fff !important;
}
.layui-tab-active-bar{
  background-color: #1e9fff !important;
}
.layui-body{
  min-height: 0 !important;
}
.layui-footer{
  line-height: 40px;
}
/*.layui-tab-content{*/
/*  display: none;*/
/*}*/




</style>
